<template>
  <div class="d-flex justify-center" >
    <div class="d-flex justify-center align-center" style="max-width:800px;">
      <div class="px-2">
        <v-avatar size="120">
          <v-img 
          :max-width="200"
          :src="human.src" 
          :lazy-src="human.srcLazy" 
          contain />
        </v-avatar>
      </div>
      <div class="px-5" style="max-width:400px;">
        <div v-html="human.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('strapiv2', ['human']),
  }
}
</script>